import { hubbleAPI } from './url'

export default ($axios) => ({
  getAccountManagerSubUsers({ jwtToken, userName = '' }) {
    const url = `${hubbleAPI}/api/am/${userName}/subusers?async=true`;
    const config = { headers: { Authorization: `Bearer ${jwtToken}` } };
    return $axios.get(url, config).then(response => response.data);
  }

})
